import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllMyFollowUps: {
        id: 'ml.gateway.views.mlActivitiesComponent.VIEW ALL MY FOLLOW UPS',
        defaultMessage: 'VIEW ALL MY FOLLOW UPS'
    },
    viewAllTasks: {
        id: 'ml.gateway.views.mlActivitiesComponent.VIEW ALL TASKS',
        defaultMessage: 'VIEW ALL TASKS'
    },
    noFollowUpActivityFound: {
        id: 'ml.gateway.views.mlActivitiesComponent.No follow-up activity found',
        defaultMessage: 'No follow-up activity found'
    },
    dueDate: {
        id: 'ml.gateway.views.mlActivitiesComponent.DUE DATE',
        defaultMessage: 'DUE DATE'
    },
    customerName: {
        id: 'ml.gateway.views.mlActivitiesComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    product: {
        id: 'ml.gateway.views.mlActivitiesComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policy: {
        id: 'ml.gateway.views.mlActivitiesComponent.QUOTE/POL #',
        defaultMessage: 'QUOTE/POL #'
    },
    initiator: {
        id: 'ml.gateway.views.mlActivitiesComponent.INITIATOR',
        defaultMessage: 'INITIATOR'
    },
    note: {
        id: 'ml.gateway.views.mlActivitiesComponent.NOTE',
        defaultMessage: 'NOTE'
    },
    assignedTo: {
        id: 'ml.gateway.views.mlActivitiesComponent.ASSIGNED TO',
        defaultMessage: 'ASSIGNED TO'
    },
    loading: {
        id: 'ml.gateway.views.mlActivitiesComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    account: {
        id: 'ml.gateway.views.mlActivitiesComponent.Account',
        defaultMessage: 'Account'
    },
    quoteToCompleteInPC: {
        id: 'ml.gateway.views.mlActivitiesComponent.Quote has not been completed. The quote must be completed in PolicyCenter.',
        defaultMessage: 'Quote has not been completed. The quote must be completed in PolicyCenter.'
    },
    quoteNotCompleteCall: {
        id: 'ml.gateway.views.mlActivitiesComponent.Quote has not been completed. Contact us at 1-800-255-0332 for assistance.',
        defaultMessage: 'Quote has not been completed. Contact us at 1-800-255-0332 for assistance.'
    },
    contactBookManager: {
        id: 'ml.gateway.views.mlActivitiesComponent.Quote has not been completed. Please contact your Book Consolidation manager.',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    addFollowUp: {
        id: 'ml.gateway.views.mlActivitiesComponent.ADD FOLLOWUP',
        defaultMessage: 'ADD FOLLOWUP'
    },
    expandButton: {
        id: 'ml.gateway.views.mlActivitiesComponent.EXPAND',
        defaultMessage: 'EXPAND'
    },
    collapseButton: {
        id: 'ml.gateway.views.mlActivitiesComponent.COLLAPSE',
        defaultMessage: 'COLLAPSE'
    },
});
